import { customElement, property } from 'lit/decorators.js';
import { State, StateController } from '@common/lit/store/index.js';
import { BaseComponent } from '@src/components/BaseComponent.js';
import { componentStateStore } from '@src/store/index.js';

@customElement('tef-coms-button')
export class TefComsButton extends BaseComponent {
  store : StateController<State>;

  @property({ type: String }) text : string = '?';

  constructor() {
    super();
    // This is needed in every component using the store to make it reactive (See lit ReactiveController)
    this.store = new StateController(this, componentStateStore);
  }

  override render() {
    return this.getTemplateFn('tefComsButton')();
  }

  handleClick(event : PointerEvent) {
    if (componentStateStore.disabled) {
      event.stopPropagation();
    }
  }

  // Render into lightDOM
  createRenderRoot() {
    return this;
  }
}
